import React, { useEffect, Fragment } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Grid,
} from '@material-ui/core';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@material-ui/icons';
import { AppBar, Page, ScreenLoader } from 'components';
import { anketsStore, guarantorStore } from 'stores';
import { ru } from 'locale';
import useStyles from './GuarantorScreen.styles';

const GuarantorScreen = observer(() => {
  const classes = useStyles();
  const { guarantorId } = useParams();
  const history = useHistory();
  const { fetchState, guarantor } = guarantorStore;

  useEffect(
    () =>
      autorun(() => {
        guarantorStore.getGuarantor(anketsStore.anketId, guarantorId);
      }),
    [guarantorId],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderIcon = checked => {
    return checked ? (
      <CheckCircleIcon className={classes.iconCheck} />
    ) : (
      <CancelIcon className={classes.iconCancel} />
    );
  };

  const renderGuarantor = () => {
    const fields = Object.keys(guarantor);

    return (
      <List aria-label={ru.guarantor}>
        {fields.map((field, idx) => {
          const value = guarantor[field];
          const showIcon = typeof value === 'boolean';
          const secondaryValue = showIcon ? null : value;

          return (
            /* eslint-disable-next-line react/no-array-index-key */
            <Fragment key={idx}>
              <ListItem>
                <ListItemText primary={ru[field]} secondary={secondaryValue} />

                {showIcon && (
                  <ListItemSecondaryAction>
                    <IconButton edge="end">{renderIcon(value)}</IconButton>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar title={ru.guarantor} onNavButtonClick={handleBackClick} />
        </Grid>

        {fetchState === 'pending' && <ScreenLoader />}
        {fetchState === 'fulfilled' && renderGuarantor()}
      </Grid>
    </Page>
  );
});

export default GuarantorScreen;
